import { LitElement as f, css as b, unsafeCSS as g, html as d, nothing as y } from "lit";
import { property as a } from "lit/decorators/property.js";
import { ifDefined as r } from "lit/directives/if-defined.js";
import { ValidationLevel as m } from "@smartdesign/field-validation-message";
const x = ":host{display:inline-flex;position:relative;cursor:text;font-family:Segoe UI,Lucida Sans,Arial,sans-serif;font-size:16px;color:#111;contain:layout style;flex-direction:column}:host([hidden]),:host([type=hidden]){display:none!important}:host([effective-disabled]){opacity:.6;cursor:default;filter:grayscale(100%)}:host([effective-disabled]) .unfocused-line,:host([effective-disabled]) .focused-line{border-bottom-style:dashed}:host(:not([effective-disabled]):focus) .focused-line,:host(:not([effective-disabled])[focused]) .focused-line{transform:none;transition:transform .25s}:host(:not([effective-disabled]):focus) .label.float,:host(:not([effective-disabled])[focused]) .label.float{color:var(--sd-input-focused-color, #1467ba)}:host([inactive]) .input{pointer-events:none}:host([effective-disabled]:focus),:host([effective-disabled][focused]){box-shadow:0 0 0 1px #111}:host(:not([effective-disabled])[validationlevel]) .focused-line{transform:none;transition:transform .25s}:host([validationlevel=warn i]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #555555)}:host([validationlevel=warn i]) .label,:host([validationlevel=warn i]) .validation-message{color:var(--sd-input-validation-color, #555555)!important}:host([validationlevel=suggest i]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #bf8800)}:host([validationlevel=suggest i]) .label,:host([validationlevel=suggest i]) .validation-message{color:var(--sd-input-validation-color, #bf8800)!important}:host([validationlevel=error i]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #cc0017)}:host([validationlevel=error i]) .label,:host([validationlevel=error i]) .validation-message{color:var(--sd-input-validation-color, #cc0017)!important}:host([validationlevel=warn]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #555555)}:host([validationlevel=warn]) .label,:host([validationlevel=warn]) .validation-message{color:var(--sd-input-validation-color, #555555)!important}:host([validationlevel=suggest]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #bf8800)}:host([validationlevel=suggest]) .label,:host([validationlevel=suggest]) .validation-message{color:var(--sd-input-validation-color, #bf8800)!important}:host([validationlevel=error]) .focused-line{border-bottom-color:var(--sd-input-validation-color, #cc0017)}:host([validationlevel=error]) .label,:host([validationlevel=error]) .validation-message{color:var(--sd-input-validation-color, #cc0017)!important}.validation-message-wrapper{position:relative}.validation-message{position:absolute;left:0;right:0}.label.float{transform:translateY(-75%) scale(.75);width:133%}.label:not(.float){max-width:100%}.floated-label-placeholder{height:20px;width:100%}.label{position:absolute;top:0;left:0;line-height:24px;pointer-events:none;color:var(--sd-input-color, #767676);transition:transform .25s,width .25s;transform-origin:left top}.input-wrapper{position:relative;display:flex;flex-direction:row;align-items:center}:host([extended-prefix]:focus:not([effective-disabled])) .input-wrapper{flex-direction:column;align-items:baseline}:host([extended-prefix]:focus:not([effective-disabled])) .input-container{width:100%}:host([extended-prefix]:not(:focus)) .input-container,:host([extended-prefix][effective-disabled]) .input-container{width:0px}.input-container{line-height:24px;flex:1 1 auto}.input{width:100%;background:var(--sd-input-background, transparent);font-family:inherit;font-size:inherit;text-align:inherit;color:inherit;border:none;outline:none;resize:none;padding-left:0;padding-right:0}.input:-webkit-autofill{animation-name:onautofillstart}.input:not(:-webkit-autofill){animation-name:onautofillcancel}@keyframes onautofillstart{0%{outline:none}}@keyframes onautofillcancel{0%{outline:none}}.label,input.input,.validation-message{text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap}.input::-ms-clear{display:none}.input::placeholder{color:var(--sd-input-color, #767676)}.input:-ms-input-placeholder{color:var(--sd-input-color, #767676)}.input::-ms-input-placeholder{color:var(--sd-input-color, #767676)}.underline{height:2px;width:100%;position:relative}.unfocused-line,.focused-line{position:absolute;top:0;right:0;bottom:0;left:0}.unfocused-line{border-bottom:1px solid var(--sd-input-underline-color, #959595)}.focused-line{border-bottom:2px solid var(--sd-input-focused-color, #1467ba);transform-origin:center center;transform:scale3d(0,1,1)}.prefix,.suffix{display:flex;flex-wrap:nowrap}.prefix ::slotted(*),.suffix ::slotted(*){display:flex}";
var w = Object.defineProperty, E = Object.getOwnPropertyDescriptor, o = (u, t, e, s) => {
  for (var n = s > 1 ? void 0 : s ? E(t, e) : t, h = u.length - 1, p; h >= 0; h--)
    (p = u[h]) && (n = (s ? p(t, e, n) : p(n)) || n);
  return s && n && w(t, e, n), n;
};
const $ = "sd-lit-input", v = "delegatesFocus" in window.ShadowRoot.prototype;
let _ = 0;
var l;
const i = (l = class extends f {
  constructor() {
    super(), this.rows = 1, this.effectiveDisabled = !1, this.type = "text", this.autocomplete = "off";
    const t = _++;
    this._validationMessageId = l.ID + "_message_" + t, this._inputId = l.ID + "_input_" + t, this.attachInternals && !this.activeShadyDOM && (this._internals = this.attachInternals());
  }
  connectedCallback() {
    super.connectedCallback(), this.hasAttribute("tabIndex") || (this.tabIndex = 0);
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.initAutocompleted(this.inputElement), this.updateInitialValue(), this.hasAttribute("disabled") && (this.disabled = !0), this.inputElement.oninput = (e) => {
      this.autocompleted = e.inputType === "insertReplacementText" || !("data" in e), this.currentText = this.inputElement.value, this.fireValueChange(!0);
    }, this.inputElement.onchange = () => this.fireValueChange(), v || (this.inputElement.onfocus = () => this.setAttribute("focused", ""), this.inputElement.onblur = () => this.removeAttribute("focused"), this.addEventListener("focus", (e) => {
      e.target === this && this.inputElement.focus();
    })), this.addEventListener("keydown", (e) => {
      var s, n;
      e.key == "Enter" && ((n = (s = this._internals) == null ? void 0 : s.form) == null || n.requestSubmit());
    }), this._initialized = !0;
  }
  initAutocompleted(t) {
    const e = (s) => {
      /^onautofillstart(-sd-lit-input-\d+|\s?)$/.test(s.animationName) ? this.autocompleted = !0 : /^onautofillcancel(-sd-lit-input-\d+|\s?)$/.test(s.animationName) && (this.autocompleted = !1);
    };
    this.activeShadyDOM ? (this._needsAutocompletedCheck = !0, this.activeShadyDOM.nativeMethods.addEventListener.call(t, "animationstart", e)) : t.addEventListener("animationstart", e);
  }
  get activeShadyDOM() {
    const t = window.ShadyDOM;
    return t && t.inUse ? t : null;
  }
  updateInitialValue() {
    typeof this.currentText < "u" ? this.value = this.currentText : this.value = this.getAttribute("value"), this.value && (this.currentText = this.inputElement.value), this._initialValue = this.value;
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(t) {
    t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled"), this._internals || (this.effectiveDisabled = t);
  }
  // It is public as hacking around due to IE 11 is a common task to do.
  get inputElement() {
    return this.shadowRoot && !this._inputElement && (this._inputElement = this.shadowRoot.querySelector(".input")), this._inputElement;
  }
  get value() {
    return this.inputElement && this.inputElement.value;
  }
  set value(t) {
    this.currentText = t || "", this.inputElement && (this.inputElement.value = this.currentText), this.setFormValue(this.currentText);
  }
  get selectionStart() {
    return this.inputElement ? this.inputElement.selectionStart : 0;
  }
  focus() {
    this.inputElement ? this.inputElement.focus() : super.focus();
  }
  select() {
    this.inputElement && this.inputElement.select();
  }
  setSelectionRange(t, e) {
    this.updateComplete.then(() => {
      this.inputElement && this.inputElement.setSelectionRange(t, e);
    });
  }
  static get styles() {
    return [
      b`
                ${g(x)}
            `
    ];
  }
  render() {
    let t;
    return this.rows === 1 ? t = d`
                <input
                    id=${this._inputId}
                    class="input"
                    .type=${this.type}
                    placeholder=${r(this.placeholder || void 0)}
                    name=${r(this.name || void 0)}
                    aria-disabled=${this.effectiveDisabled}
                    autocomplete=${this.autocomplete}
                    ?disabled=${this.inactive}
                    ?readonly=${this.readonly || this.effectiveDisabled}
                    ?required=${this.required}
                    maxlength=${this.maxlength > 0 ? this.maxlength : l.DEFAULT_MAX_LENGTH}
                    aria-describedby=${this._validationMessageId}
                    aria-invalid=${r(!!this.validationMessage || void 0)}
                    aria-label=${r(this.sdAriaLabel || void 0)}
                />
            ` : t = d`
                <textarea
                    id=${this._inputId}
                    class="input"
                    placeholder=${r(this.placeholder || void 0)}
                    name=${r(this.name || void 0)}
                    aria-disabled=${this.effectiveDisabled}
                    autocomplete=${this.autocomplete}
                    ?disabled=${this.inactive}
                    ?readonly=${this.readonly || this.effectiveDisabled}
                    ?required=${this.required}
                    maxlength=${this.maxlength > 0 ? this.maxlength : l.DEFAULT_MAX_LENGTH}
                    rows=${this.rows}
                    aria-describedby=${this._validationMessageId}
                    aria-invalid=${r(!!this.validationMessage || void 0)}
                    aria-label=${r(this.sdAriaLabel || void 0)}
                ></textarea>
            `, d`
            ${this.label ? d` <div class="floated-label-placeholder" aria-hidden="true">&nbsp;</div> ` : y}
            <div class="input-wrapper">
                <span class="prefix"><slot name="prefix"></slot></span>
                <div class="input-container" style="position:${this.shouldFloat() ? "static" : "relative"};">
                    ${this.label && d`
                        <label for="${this._inputId}" class="label ${this.shouldFloat() ? "float" : ""}"
                            >${this.label}</label
                        >
                    `}
                    ${t}
                </div>
                <span class="suffix"><slot name="suffix"></slot></span>
            </div>
            <div class="underline" aria-hidden="true">
                <div class="unfocused-line"></div>
                <div class="focused-line"></div>
            </div>
            <div class="validation-message-wrapper" aria-hidden="true">
                ${this.validationMessage && d`
                    <sd-field-validation-message
                        id=${this._validationMessageId}
                        class="validation-message"
                        .message=${this.validationMessage}
                        .icon=${this.validationIconSrc}
                        .level=${this.validationLevel}
                    >
                    </sd-field-validation-message>
                `}
            </div>
        `;
  }
  updated(t) {
    super.updated(t), this._needsAutocompletedCheck && !this.autocompleted && setTimeout(() => {
      try {
        this.autocompleted = this.autocompleted || !!this.shadowRoot.querySelector(":-webkit-autofill");
      } catch {
      }
    }, 0);
  }
  update(t) {
    var e, s;
    if (super.update(t), t.has("validationMessage") && (this.validationMessage ? (this.validationLevel || (this.validationLevel = m.Error), (e = this._internals) == null || e.setValidity({ customError: !0 }, this.validationMessage)) : (this.validationLevel = null, (s = this._internals) == null || s.setValidity({}))), this._initialized && t.has("rows"))
      throw Error("rows attribute cannot be changed after the input is attached to the DOM");
  }
  fireValueChange(t) {
    this.dispatchEvent(
      new CustomEvent(`${t ? "immediate-" : ""}value-change`, {
        detail: { value: this.value }
      })
    ), this.setFormValue(this.value);
  }
  shouldFloat() {
    return this.alwaysFloatLabel || this.currentText || this.placeholder || this.autocompleted;
  }
  setFormValue(t) {
    var e;
    (e = this._internals) == null || e.setFormValue(t);
  }
  formResetCallback() {
    this.value = this._initialValue;
  }
  formDisabledCallback(t) {
    this.effectiveDisabled = t || this.hasAttribute("disabled");
  }
  formAssociatedCallback(t) {
    this._needsAutocompletedCheck = !0;
  }
  formStateRestoreCallback(t, e) {
    typeof t == "string" && (this.value = t);
  }
}, l.ID = $, l.DEFAULT_MAX_LENGTH = 524288, l.formAssociated = !0, l.shadowRootOptions = {
  ...f.shadowRootOptions,
  delegatesFocus: v
}, l);
o([
  a({ type: String, reflect: !0 })
], i.prototype, "label", 2);
o([
  a({ type: String, attribute: !0 })
], i.prototype, "validationMessage", 2);
o([
  a({ type: String, attribute: !0 })
], i.prototype, "validationIconSrc", 2);
o([
  a({ type: m, attribute: !0, reflect: !0 })
], i.prototype, "validationLevel", 2);
o([
  a({
    type: String,
    hasChanged(u, t) {
      return t != null && t != u;
    }
  })
], i.prototype, "currentText", 2);
o([
  a({ type: Boolean, attribute: !0 })
], i.prototype, "alwaysFloatLabel", 2);
o([
  a({ type: Boolean, attribute: !0 })
], i.prototype, "autocompleted", 2);
o([
  a({ type: Number, attribute: !0 })
], i.prototype, "rows", 2);
o([
  a({ type: Boolean, reflect: !0, attribute: "effective-disabled" })
], i.prototype, "effectiveDisabled", 2);
o([
  a({ type: Boolean, reflect: !0, attribute: "extended-prefix" })
], i.prototype, "extendedPrefix", 2);
o([
  a({ type: String, reflect: !0 })
], i.prototype, "type", 2);
o([
  a({ type: String, reflect: !0 })
], i.prototype, "placeholder", 2);
o([
  a({ type: String, reflect: !0 })
], i.prototype, "sdAriaLabel", 2);
o([
  a({ type: Number, reflect: !0 })
], i.prototype, "maxlength", 2);
o([
  a({ type: Boolean, reflect: !0 })
], i.prototype, "readonly", 2);
o([
  a({ type: Boolean, reflect: !0 })
], i.prototype, "required", 2);
o([
  a({ type: String, reflect: !0 })
], i.prototype, "name", 2);
o([
  a({ type: Boolean, reflect: !0 })
], i.prototype, "inactive", 2);
o([
  a({ type: String, attribute: !0 })
], i.prototype, "autocomplete", 2);
let c = i;
customElements.get(c.ID) || customElements.define(c.ID, c);
export {
  c as default
};
//# sourceMappingURL=input.mjs.map
